/* WINGBABE · sticky-atc · vanilla JS, no dependencies */
(function(){
/* Bar slides away while the main Add to bag button is on screen; its button triggers the main one. */
var bar=document.querySelector('[data-sticky-atc]'),main=document.querySelector('[data-add-to-cart]');if(!bar||!main)return;
if('IntersectionObserver' in window)new IntersectionObserver(function(es){bar.classList.toggle('is-hidden',es[0].isIntersecting);}).observe(main);
var b=bar.querySelector('[data-sticky-atc-button]');if(b)b.addEventListener('click',function(){main.click();});
})();
